// todo
const host = 'http://www.baidu.com/';
// const host = 'http://192.168.1.8:8080/';
const pageSize = 10

let contractAddress =
  //正式合约
  {
      "USDTToken": "0x55d398326f99059fF775485246999027B3197955",
      "LockPool": "0xA95Bf1F9EE9a87E2Bbd176aca724B8f2Cd1c426E",
      "UserContract": "0x2a55a53bB7e91109037A31f0B7Bd04C24FB47C97",
      "DailyIncomeContract": "0x5E28DaE333263BC861939C9E1CBA5e6FD7021e18",
      "PoolTraditional": "0x6C6cF52e2a77a2c5B6426a85Aaa0611F39782138",
      "CFCToken": "0x7CF622Ee270Ce54EB047BE68049C79180110664A",
      "PowerRelease": "0x71a7FBE3BFBfb0c8029e77E801FD3Cc08B3d405E"
  }
//  li新cfc测试合约
//   {
//       "USDTToken": "0x1eae29d05A2e4A59690748C39f81D44358312a90",
//       "LockPool": "0xf46a6A4BA1Cd8bE52c767f4cC9Bbd201DCd47bBe",
//       "UserContract": "0x2940a81e099354DC0f9333004Ea0fB9C6926B28d",
//       "DailyIncomeContract": "0x0cAF35C76F73412C7Aa575a035E723dF23d7F257",
//       "PoolTraditional": "0x358A1c89b9f525483F74D3167d35aB2298610E9d",
//       "CFCToken": "0x412E6206beB10331f314E98F14900ceA2f50B023",
//       "PowerRelease": "0x0AE429A9e2C77D320c192DDb3Cc1CDfecFAa9Fae"
//   }

  let powerReleaseCreateBlock = 27019045;
  // let powerReleaseCreateBlock = 28405414;
// debug true:测试  false:正式
const devUrl = [
    "test",
    "trei",
    "dectest",
    "localhost",
    "192.168",
    "8.210.239.89",
];

const getEnv = () => {
    const link = window.location.href;
    let isDebug = false;
    for (let k in devUrl) {
        if (link.indexOf(devUrl[k]) !== -1) {
            isDebug = true;
        }
    }
    return isDebug;
};
let debug = getEnv();
debug = false
// console.log('debug', debug)

const data = {
    build: {
        name: "mainnet",
        network: "",
        explorer1: "",
        explorer2: "",
        explorer3: "",
        nodeLink: "https://bsc-dataseed.binance.org",
        eventRPC: "https://rpc-bsc.48.club",
        nodeId: 56,
        httpApi: "",
        token: "",
        consumer_key: "",
        consumer_secret: "",
        aiToken: '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',
        aiApi: 'https://api.openai.com/v1/',
        // token: 'AAAAAAAAAAAAAAAAAAAAADjSoQEAAAAAhFsaRIV2HsJp5SZ2LsavW5BQjQk%3DHCj3205LtSZe16t92dPv2trwHtHihK6XNLsu9N54UwDmHnEicZ',
        // httpApi: 'https://api.twitter.com/',
        newsToken: 'nmM6fqzpBPZjR8GrL7aOwHBTOEb501G3',
        newsApi: 'https://api.cryptodaoapp.com/news/',
        "USDTToken": "0x55d398326f99059fF775485246999027B3197955",
        "LockPool": "0xA95Bf1F9EE9a87E2Bbd176aca724B8f2Cd1c426E",
        "UserContract": "0x2a55a53bB7e91109037A31f0B7Bd04C24FB47C97",
        "DailyIncomeContract": "0x5E28DaE333263BC861939C9E1CBA5e6FD7021e18",
        "PoolTraditional": "0x6C6cF52e2a77a2c5B6426a85Aaa0611F39782138",
        "CFCToken": "0x7CF622Ee270Ce54EB047BE68049C79180110664A",
        "PowerRelease": "0x71a7FBE3BFBfb0c8029e77E801FD3Cc08B3d405E"
    },
    dev: {
        name: "testnet",
        network: "?network=testnet",
        explorer1: "https://explorer.sui.io/object/",
        explorer2: "https://explorer.sui.io/address/",
        explorer3: "https://explorer.sui.io/transaction/",
        nodeLink: "https://data-seed-prebsc-2-s2.binance.org:8545",
        eventRPC: "https://data-seed-prebsc-2-s2.binance.org:8545",
        nodeId: 97,
        httpApi: "https://tapi.gugle3.xyz/api/v1",
        // httpApi: "http://localhost:3001/api/v1",
        token: "63a13ff99d9710340d31ecff637c06fe",
        consumer_key: "1459073754349600768-EAB6EVk9P2qtyivYB9WRj13zTaL672",
        consumer_secret: "RwLVYXffm5SZtp7Ech5gNdYWmMGdDqWwZFpxgthfTDphE",
        aiToken: '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',
        aiApi: 'https://api.openai.com/v1/',
        // token: 'AAAAAAAAAAAAAAAAAAAAADjSoQEAAAAAhFsaRIV2HsJp5SZ2LsavW5BQjQk%3DHCj3205LtSZe16t92dPv2trwHtHihK6XNLsu9N54UwDmHnEicZ',
        // httpApi: 'https://api.twitter.com/',
        newsToken: 'nmM6fqzpBPZjR8GrL7aOwHBTOEb501G3',
        newsApi: 'https://api.cryptodaoapp.com/news/',
        "USDTToken": "0x1eae29d05A2e4A59690748C39f81D44358312a90",
        "LockPool": "0xf46a6A4BA1Cd8bE52c767f4cC9Bbd201DCd47bBe",
        "UserContract": "0x2940a81e099354DC0f9333004Ea0fB9C6926B28d",
        "DailyIncomeContract": "0x0cAF35C76F73412C7Aa575a035E723dF23d7F257",
        "PoolTraditional": "0x358A1c89b9f525483F74D3167d35aB2298610E9d",
        "CFCToken": "0x412E6206beB10331f314E98F14900ceA2f50B023",
        "PowerRelease": "0x0AE429A9e2C77D320c192DDb3Cc1CDfecFAa9Fae"
    },
};
let configAll = data.build;
if (debug) {
    configAll = data.dev;
}
// console.log('configAll', configAll)
export default configAll;
export {
  host,
  pageSize,
  contractAddress,
  powerReleaseCreateBlock
}
